// reduced-motion(또는 matchMedia 미지원 — SSR/test)이면 모션 생략 → enter/exit 동기.
export const prefersReducedMotion = (): boolean =>
  typeof window === "undefined" ||
  typeof window.matchMedia !== "function" ||
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
